import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store'
import { Operations, DataEntity, StoreOperation, StoreOperationUpdate } from '@/entity/warehouse/Operations/Operations.types';
import { PaginationRequestType } from '@/entity/common/pagination.types'
import { prepareFormData } from '@/store/utils/formDataHelper'
import {ResponseDataType} from "@/form/form.types";

@Module({
    namespaced: true,
    name: 'operations',
    store,
    dynamic: true,
})
class OperationsModule extends VuexModule implements IStoreReady{
    operations: Operations | null = null
    operation: DataEntity | null = null

    operationLoaded = false
    operationsLoaded = false

    ready = false

    @MutationAction
    async fetchAll( data?: PaginationRequestType ):Promise<{operations:Operations; operationsLoaded:boolean }>{

        let operationsLoaded = false
        const operations = await store.$repository.operations.fetchAll(prepareFormData(data))
        if (operations) {operationsLoaded = true
        }
        return {operations, operationsLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{operation: DataEntity; operationLoaded:boolean}>{
        let operationLoaded = false
        const operation = await store.$repository.operations.fetchData(data)
        if (operation) {
            operationLoaded = true
        }
        return { operation, operationLoaded }
    }

    @Action({rawError: true})
    async create(data: StoreOperation): Promise<ResponseDataType> {
        console.log('Store Operation ---'+ data)
        return await store.$repository.operations.OperationAction(data);
    }

    @Action({rawError: true})
    async update(data:StoreOperationUpdate): Promise <ResponseDataType> {
        return await store.$repository.operations.update(data);
    }

    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
}
export const OperationsStore = getModule(OperationsModule)